<template>
  <div id="jiexiwancheng" v-if="finish">
    <div id="sssecc">
      <h2>
        {{ exportTaskPro == 100 ? "解析完成！" : "正在解析地址" }}
      </h2>
      <Progress :percent="exportTaskPro" />
      <Row :gutter="16" style="margin-top: 30px">
        <Col span="12"
          ><Button long @click="delExportTask" :disabled="exportTaskPro == 0"
            >取消任务</Button
          ></Col
        >
        <Col span="12"
          ><Button
            long
            @click="exportData"
            :loading="exportTaskPro != 100"
            type="primary"
            ><span v-if="exportTaskPro == 100">下载文件</span>
            <span v-else>请等待</span></Button
          ></Col
        >
      </Row>
    </div>
  </div>
</template>
<script>
var jindu;
import axios from "axios";
export default {
  data() {
    return {
      finish: false,
      exportTaskPro: 0,
      taskId: 0,
      item: {
        deviceNo: "",
        endTime: 0,
        returnCoord: 2,
        startTime: 0,
        type: 0, //类型（1-车辆运动轨迹，2-车辆原始轨迹，3-人员正常轨迹，4-人员原始轨迹）
        //pageNumber: 0,
        //pageSize: 0,
      },
    };
  },
  methods: {
    reachData(v) {
      this.item.deviceNo = v.deviceNo;
      this.item.startTime = v.start.getTime();
      this.item.endTime = v.end.getTime();
      if (v.tt == "车辆") {
        if (v.val == 1) {
          this.item.type = 1;
        } else {
          this.item.type = 2;
        }
      } else {
        if (v.val == 1) {
          this.item.type = 3;
        } else {
          this.item.type = 4;
        }
      }
      this.addExportTask();
    },
    exportData() {
      var params = [
        {
          name: "taskId",
          value: this.taskId,
        },
      ];
      var url = "/exportTask/export";
      /* this.select.val == 1
        ? (url = "/locus/exportList")
        : (url = "/locus/exportAll"); */

      this.utils.exportData(axios.lbs + url, params);
      this.finish = false;
      this.exportTaskPro = 0;
    },
    //新疆下载任务
    addExportTask() {
        console.log(this.item);
      this.finish = true;
      axios({
        method: "post",
        url: axios.lbs + "/exportTask/add/locus",
        data: this.item,
      }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.taskId = res.data.data;
          jindu = setInterval(() => {
            this.getExportTaskPro();
          }, 1000);
        }
      });
    },
    //删除下载任务
    delExportTask() {
      clearInterval(jindu);
      let params = {
        taskId: this.taskId,
      };
      axios({
        method: "post",
        url: axios.lbs + "/exportTask/del",
        data: params,
      }).then((res) => {
        if (res) {
          this.finish = false;
        }
      });
    },
    getExportTaskPro() {
      let params = {
        taskId: this.taskId,
      };
      axios({
        method: "post",
        url: axios.lbs + "/exportTask/pro",
        data: params,
      }).then((res) => {
        console.log(res);
        this.exportTaskPro = res.data.data;
        if (this.exportTaskPro == 100) {
          clearInterval(jindu);
        }
      });
    },
  },
};
</script>
<style>
#jiexiwancheng {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 22222;
  background: rgba(0, 0, 0, 0.2);
}
#jiexiwancheng #sssecc h2 {
  font-size: 18px;
  margin-bottom: 10px;
}
#jiexiwancheng #sssecc {
  width: 300px;
  padding: 20px;
  border-radius: 6px;
  background: rgba(255, 255, 255);
  margin: 100px auto;
  box-shadow: 10px 10px 20px rgb(129, 129, 129);
}
</style>


// WEBPACK FOOTER //
// src/components/locus/export.vue